import React from 'react';

import { Helmet } from 'react-helmet';
import Paper from '@mui/material/Paper';

import NotesList  from 'src/component/UI/NotesList';
import FilterBar from 'src/component/UI/FilterBar';

import { fetchNotes } from 'src/module/note/action';
import { getLotoNotes, getLoadingLotoNotes, getNumLotoNotesPages, getTotalLotoNotes } from 'src/module/note/selector';
import { isWhitelabel } from 'src/utils/utils';
import { useTranslation } from 'src/i18n';

export default function LotoScreen () {
  const { t } = useTranslation();
  const selectors = {
    getNotes: getLotoNotes,
    getLoadingNotes: getLoadingLotoNotes,
    getNumNotesPages: getNumLotoNotesPages,
    getTotalNotes: getTotalLotoNotes
  };

  const title = isWhitelabel() ? 'ATCOM' : 'SmartTrace';

  return (
    <div className='page' id='loto-screen'>
      <Helmet>
        <title>{title} - {t('notes.lotoScreen')} - Lock-Out Tag-Out</title>
      </Helmet>
      <FilterBar includeGrid />
      <br />
      <Paper>
        <NotesList
          noteType={'loto'}
          selectors={selectors}
          showSubject
          showExpiry
          showAddNoteButton
          showSearchBar
          showArchivedOption
          showDeleteIcon
          fetch={fetchNotes}
        />
      </Paper>
    </div>
  );
}
